import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "mb-5 mt-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-male" }, null, -1)
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_10 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Email")
], -1)
const _hoisted_11 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_12 = {
  key: 0,
  title: "Email confirmed",
  class: "text-success"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_14 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_16 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "Created At", -1)
const _hoisted_18 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_19 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", null, "Total Files", -1)
const _hoisted_21 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "d-flex justify-content-between" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" No Files. ")
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, {
    title: "File History",
    allowBack: true
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h4", _hoisted_3, [
            _createVNode("b", null, [
              _createTextVNode(_toDisplayString(_ctx.selectedUser?.firstName || '--') + " " + _toDisplayString(_ctx.selectedUser?.lastName || '--') + " ", 1),
              (_ctx.selectedUser?.corporate)
                ? (_openBlock(), _createBlock("span", _hoisted_4, [
                    _hoisted_5
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_6, [
                    _hoisted_7
                  ]))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("h6", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.selectedUser?.email) + " ", 1),
            (_ctx.selectedUser?.emailConfirmed)
              ? (_openBlock(), _createBlock("span", _hoisted_12, [
                  _hoisted_13
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_14, [
                  _hoisted_15
                ]))
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("b", null, [
            _hoisted_17,
            _createVNode("h6", _hoisted_18, _toDisplayString(_ctx.formatDate(_ctx.selectedUser?.createdAt)), 1)
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("b", null, [
            _hoisted_20,
            _createVNode("h6", _hoisted_21, _toDisplayString(_ctx.getTotalFiles), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (list, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "row mb-3",
          key: index
        }, [
          _createVNode("div", _hoisted_22, [
            _createVNode(_component_DataTable, {
              value: list,
              autoLayout: true,
              filterDisplay: "menu",
              paginator: true,
              rows: 10,
              rowsPerPageOptions: [10, 20, 50],
              paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
            }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.separeteByCapital(list[0].typeOfDocument)), 1)
              ]),
              empty: _withCtx(() => [
                _hoisted_24
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "key",
                  header: "Name",
                  bodyStyle: "text-align: left"
                }),
                _createVNode(_component_Column, {
                  field: "fileMimetype",
                  header: "File Type",
                  bodyStyle: "text-align: left"
                }),
                _createVNode(_component_Column, {
                  field: "uploadedAt",
                  header: "Uploaded At",
                  bodyStyle: "text-align: left"
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Action",
                  bodyStyle: "text-align: left"
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("button", {
                      class: "btn btn-sm btn-primary",
                      onClick: ($event: any) => (_ctx.downloadDocument(slotProps.data))
                    }, [
                      _hoisted_25
                    ], 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["value"])
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}